// AdminLayout — Layout route pour les pages d'administration
// Ajoute le contexte Refine et le bandeau "Administration"
// Utilise comme layout route imbriquee dans DashboardLayout

import { Outlet } from 'react-router-dom'
import { Refine } from '@refinedev/core'
import routerProvider from '@refinedev/react-router'
import { dataProvider } from '../../lib/refine-data-provider'
import { authProvider } from '../../lib/refine-auth-provider'

export default function AdminLayout() {
  return (
    <Refine
      dataProvider={dataProvider('/api/admin')}
      routerProvider={routerProvider}
      authProvider={authProvider('/api')}
      resources={[
        {
          name: 'attestations',
          list: '/admin/attestations',
          show: '/admin/attestations/:id',
          meta: { label: 'Attestations' },
        },
      ]}
      options={{ disableTelemetry: true }}
    >
      <div>
        <div className="mb-6">
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-1">
            Administration
          </p>
        </div>
        <Outlet />
      </div>
    </Refine>
  )
}
